import { copy } from 'shared/lib/copy';
import { propertyApplication, propertyType, userScopeType } from 'shared/constants.json';
import { walkFilter } from '@/lib/filter/filter';

const filterFunc = (child) => {
  if (child.scope.property !== undefined
    && (child.scope.property.usedFor.includes(propertyApplication.user) || child.scope.users.length > 0 || child.scope.property.type === propertyType.lookup)
  ) {
    return true;
  }

  return false;
};

const toStaticUsers = (c) => {
  if (c.scope.property.type === propertyType.lookup) {
    return {
      ...c,
      scope: {
        ...c.scope,
        property: c.scope.property.lookupProperty,
        type: userScopeType.property,
        users: c.scope.users,
        spaces: c.scope.spaces,
        selectedOptions: c.scope.selectedOptions,
      },
    };
  }

  if (c.scope.users === undefined || c.scope.users.length === 0) {
    return c;
  }

  return {
    ...c,
    scope: {
      ...c.scope,
      users: [],
      property: null,
      staticUsers: c.scope.users,
      type: userScopeType.staticUsers,
    },
  };
};

export const transformToUserFilter = ({ filter }) => {
  if (filter === null) {
    return null;
  }

  const res = copy(filter);
  res.children = filter.children.reduce(walkFilter(filterFunc, toStaticUsers), []);

  return res;
};
